import React, { useState, useEffect } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { temPedidoAnonimo } from '../services/pedidoAnonimo';

function PedidoVinculadoToast() {
  const [show, setShow] = useState(false);
  const [pedidoInfo, setPedidoInfo] = useState(null);

  useEffect(() => {
    // Verificar se há pedido anônimo ao carregar
    const verificarPedido = async () => {
      const { obterPedidoAnonimo } = await import('../services/pedidoAnonimo');
      const pedido = obterPedidoAnonimo();
      
      if (pedido) {
        setPedidoInfo(pedido);
      }
    };

    verificarPedido();

    // Escutar evento customizado de pedido vinculado
    const handlePedidoVinculado = (event) => {
      setPedidoInfo(event.detail);
      setShow(true);
    };

    window.addEventListener('pedidoVinculado', handlePedidoVinculado);

    return () => {
      window.removeEventListener('pedidoVinculado', handlePedidoVinculado);
    };
  }, []);

  if (!pedidoInfo) return null;

  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
      <Toast 
        show={show} 
        onClose={() => setShow(false)} 
        delay={5000} 
        autohide
        bg="success"
        className="text-white"
      >
        <Toast.Header closeButton={false}>
          <strong className="me-auto">Pedido Vinculado!</strong>
        </Toast.Header>
        <Toast.Body>
          Seu pedido #{pedidoInfo.comandaId} foi vinculado à sua conta com sucesso!
          <br />
          <small>Agora você pode acompanhar o status em "Meus Pedidos"</small>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

export default PedidoVinculadoToast;